import { salesforceWebToLead } from '@codecs/salesforce';
import { environment } from '@lib/environment';
import { validatePhoneE164 } from '@lib/format';
import { getUtms } from '@lib/Utilities';
import { SalesforceWebToLead } from '@src/models/SalesforceWebToLead';
import { jsonapiCreate } from '@vacasa/jsonapi';
import axios from 'axios';
import { createCancelToken } from './cancelToken';

export async function saveSalesforceWebToLead(
    lead: SalesforceWebToLead,
): Promise<SalesforceWebToLead | undefined> {
    const url = `/v1/salesforce/lead`;
    const salesforceUTM = getUtms();

    if (lead.phone) {
        const response = validatePhoneE164(lead.phone);
        if (response.startsWith('+')) {
            lead.phone = response;
        } else {
            console.error(response);
        }
    }

    lead.segmentUserID = analytics?.user?.().anonymousId();

    return await jsonapiCreate({
        baseURL: environment.REACT_APP_API_URL(),
        url,
        data: {
            data: {
                type: 'salesforce-lead',
                attributes: { ...lead, ...salesforceUTM },
            },
        },
        cancelToken: createCancelToken('saveSalesforceWebToLead'),
        decoder: salesforceWebToLead,
    })
        .then((response) => response.data.data.attributes)
        .catch((err) => {
            if (!axios.isCancel(err)) {
                console.error(`POST ${url} failed`, err);
            }

            return undefined;
        });
}
